import PropTypes from "prop-types";
import Image from "next/image";
import useTranslation from "next-translate/useTranslation";
import { useState } from "react";

import { formatMoney } from "@utils/helpers/common";
import { formatImage } from "@utils/helpers/logic/image";
import { ASSETS_URL, CONVERT_RATE } from "configs/constant";

import defaultImg from "@public/images/mockup-course.png";
import iconCoin from "@public/icons/icon-coin.svg";

CardProduct.propTypes = {
  onClick: PropTypes.func,
  data: PropTypes.object,
  hasCourseTemplate: PropTypes.bool,
};

const defaultProps = {
  onClick: () => {},
  data: {},
  hasCourseTemplate: false,
};

export default function CardProduct({ onClick, data, hasCourseTemplate }) {
  const { t } = useTranslation("cardProduct");

  const [imageLoaded, setImageLoaded] = useState(false);

  const TEMP_IMAGE_URL =
    "https://daotaoclbberich.s3.ap-southeast-1.amazonaws.com/fmdaotao/images";

  const tempImageUrlFormat = (link) => {
    const splitArr = link?.split("/");

    return splitArr?.at(-1);
  };

  return (
    <div className="card-product">
      {hasCourseTemplate ? (
        <div className="card-product__img">
          <Image
            src={
              data?.image && imageLoaded
                ? `${TEMP_IMAGE_URL}/${tempImageUrlFormat(data?.image)}`
                : defaultImg
            }
            alt="course"
            layout="fill"
            onLoadingComplete={() => {
              setImageLoaded(true);
            }}
          />
        </div>
      ) : (
        <div className="card-product__img">
          <Image
            src={
              data?.thumbnail?.length > 0 && imageLoaded
                ? `${ASSETS_URL}/${formatImage(data?.thumbnail)}`
                : defaultImg
            }
            alt="board-kit"
            layout="fill"
            onLoadingComplete={() => {
              setImageLoaded(true);
            }}
          />
        </div>
      )}
      <div className="card-product__content">
        <p className="card-product__content--title">{data?.name}</p>
        {hasCourseTemplate && (
          <p className="card-product__content--category">{data?.category}</p>
        )}
        <div className="card-product__content--option">
          <button
            className="card-product__content--option--button"
            onClick={onClick}
          >
            {data?.is_bought ? t("owned") : t("buyNow")}
          </button>
          <div className="card-product__content--option--price">
            <p className="card-product__content--option--price--number">
              {!hasCourseTemplate
                ? data?.coin
                : formatMoney(Number(data?.price) / CONVERT_RATE, false) || "0"}
            </p>
            <Image src={iconCoin} alt="course" width={20} height={20} />
          </div>
        </div>
      </div>
    </div>
  );
}

CardProduct.defaultProps = defaultProps;
